export const logout = async () => {
  const link = localStorage.getItem("homeLink")
  sessionStorage.removeItem("token")
  localStorage.removeItem("USER_INFO")
  localStorage.removeItem("authToken")
  localStorage.removeItem("userId")
  localStorage.removeItem("username")
  localStorage.removeItem("expirationDate")
  localStorage.removeItem("loginType")
  localStorage.removeItem("userType")
  localStorage.removeItem("userProfile")
  localStorage.removeItem("userProfileImage")
  localStorage.removeItem("userProfileImageUrl")

  window.location.assign(link || `/`)
  localStorage.removeItem("homeLink")
}
